import { store } from '../redux/store'
var axios = require('axios')
var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

const rootService = (props) => {
  return (
    {
      sctAnalytics: axios.create({
        baseURL: `https://sct.intutrack.com/api/test/`,
        headers: {
          Authorization: `Bearer ${store.getState().app.token}`,
          'x-request-source': 'web-ui'
        },
      })
    }
  )
} 

export default rootService